// import React, { useEffect, useRef, useState } from 'react';
// import { Rnd } from 'react-rnd';

// const style = {
//   border: 'solid 1px #ddd',
//   background: '#f0f0f0',
//   outline: '2px solid #ff0000', // This adds a red outline
// };

// const UserVideo = () => {
//   const videoRef = useRef(null);
//   const [recorder, setRecorder] = useState(null);
//   const [chunks, setChunks] = useState([]);

//   useEffect(() => {
//     navigator.mediaDevices.getUserMedia({ video: true })
//       .then((stream) => {
//         if (videoRef.current) {
//           videoRef.current.srcObject = stream;
//           const mediaRecorder = new MediaRecorder(stream);
//           setRecorder(mediaRecorder);
//         }
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(() => {
//     if (recorder) {
//       recorder.start();
//       recorder.ondataavailable = e => setChunks(prev => [...prev, e.data]);
//       recorder.onstop = exportVideo;
//     }
//   }, [recorder]);

//   const exportVideo = () => {
//     var blob = new Blob(chunks, { type: "video/mp4" });
//     var url = URL.createObjectURL(blob);
//     // here is the URL of the recorded video. You can save it somewhere or stream it to your server
//     console.log(url);
//     setChunks([]);
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (recorder && recorder.state === "recording") {
//         recorder.stop();
//         recorder.start();
//       }
//     }, 30000);
//     return () => clearInterval(interval);
//   }, [recorder]);

//   return (
//     <Rnd
//       style={style}
//       default={{
//         // x: window.innerWidth - 200,
//         y: 0,
//         width: 200,
//         height: 150,
//       }}
//     >
//       <video ref={videoRef} autoPlay muted style={{ width: '100%', height: '100%' }} />
//     </Rnd>
//   );
// };

// export default UserVideo;

import React from "react";
// import AzureBlobStorageClient from "./AzureBlobStorage";

const UserVideoNew = React.forwardRef((props, ref) => {
  const videoRef = React.useRef();
  React.useImperativeHandle(
    ref,
    () => ({
      setVideoStreamSrcObject: function (stream) {
        videoRef.current.srcObject = stream;
      },
    }),
    []
  );

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      style={{
        width: "100%",
        height: "100%",
        // border: "5px solid red ",
        position: "absolute",
        top: 0,
        left: 0,
        borderRadius: "12px",
        objectFit: "cover",
        zIndex: 0,
      }}
    />
  );
});

export default UserVideoNew;
